import { render, staticRenderFns } from "./RegionSeoBlock.vue?vue&type=template&id=5a8822ae"
import script from "./RegionSeoBlock.vue?vue&type=script&lang=js"
export * from "./RegionSeoBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports